import { Link } from "react-router-dom";

export type LifestyleLuxeMastheadProps = {
  testId?: string;
  mastheadPath: string;
  logoSrc: string;
  logoWidth: string;
  logoHeight: string;
};

export default function LifestyleLuxeMasthead({
  testId = "lifestyleluxe-masthead",
  mastheadPath,
  logoSrc,
  logoWidth,
  logoHeight,
}: LifestyleLuxeMastheadProps): React.ReactElement {
  return (
    <>
      <div
        className="flex w-full flex-grow flex-col items-center"
        data-testid={testId}
      >
        <Link to={`/${mastheadPath}`} rel="noopener noreferer" reloadDocument>
          <img src={logoSrc} width={logoWidth} height={logoHeight} />
        </Link>
      </div>
    </>
  );
}
